import React, { useEffect, useState } from "react";
import axios from "axios";
import "./TicketAssessments.css";
axios.defaults.withCredentials = true;

const StarRating = ({ value }) => {
  const stars = Array.from({ length: 5 }, (_, i) => (
    <span key={i} className={i < value ? "star filled" : "star"}>
      ★
    </span>
  ));
  return <div className="stars">{stars}</div>;
};

const TicketAssessments = () => {
  const [assessments, setAssessments] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "/ticketadmin/assessments",
          {
            withCredentials: true,
          }
        );
        setAssessments(res.data);
      } catch (err) {
        console.error("Error fetching assessments", err);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="assessment-container">
      <h2>Ticket Assessments</h2>
      <table className="assessment-table">
        <thead>
          <tr>
            <th>Ticket</th>
            <th>Subject</th>
            <th>Customer</th>
            <th>การบริการ</th>
            <th>ความรวดเร็ว</th>
            <th>ความพึงพอใจ</th>
            <th>Avg Score</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {assessments.map((item) => {
            const avgScore = (
              (Number(item.Q1) + Number(item.Q2) + Number(item.Q3)) /3).toFixed(2);
            return (
              <tr key={item.id}>
                <td>{item.ticket_id}</td>
                <td>{item.issue_summary}</td>
                <td>{item.customer_name}</td>
                <td>
                  <StarRating value={item.Q1} />
                </td>
                <td>
                  <StarRating value={item.Q2} />
                </td>
                <td>
                  <StarRating value={item.Q3} />
                </td>
                <td>{avgScore}</td>  
                <td>
                  {new Date(item.created_at).toLocaleString("th-TH", {
                    timeZone: "Asia/Bangkok",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TicketAssessments;
